import React from "react";
import WelcomeHeader from "taskpane/components/welcomeHeader";
import WelcomeText from "taskpane/components/welcomeText";

const WelcomePage: React.FC = (): React.JSX.Element => {
  return (
    <div data-testid="welcomePage">
      <WelcomeHeader logo="assets/logo.svg" title="VK Teams" />
      <WelcomeText />
    </div>
  );
};

export default WelcomePage;
